import React from "react"
import { GetStaticPaths, GetStaticPathsResult, GetStaticProps, GetStaticPropsResult } from "next"
import { GetCourseListFilterOptions } from "../../lib/prismic/courses"
import { TypeCourseTypeTechnologyPageComponent } from "../../components/Pages/TypeCourseTypeTechnology"
import { CourseAgeGroup, CourseType, CourseVariant } from "../../lib/prismic/Course"
import { webUrl } from "../../config/web"
import { Reason, reasons } from "../../lib/lists/reasons"
import { getAllProducts, ProductsColorsItem } from "../../lib/contentful/product/getAllProducts"
import { isProductAvailable } from "../../lib/prismic/getCourse"
import { Entry } from "contentful"
import { TypeProductEntitySkeleton } from "../../lib/contentful/ContentfulVzdelanibudoucnostiTypes"

const OnlineKrouzekProDeti3dTisk = ({ openTraineeCourses, productsColors, reason }: Props) => {
  if (!reason) {
    return <div>neni</div>
  }

  const { slug, title, long_description, description, seoDescription, keywords } = reason

  return (
    <TypeCourseTypeTechnologyPageComponent
      courses={openTraineeCourses}
      productsColors={productsColors}
      title={title}
      description={description}
      keywords={keywords}
      long_description={long_description}
      seoDescription={seoDescription}
      url={`${webUrl}/${slug}`}
    />
  )
}

export default OnlineKrouzekProDeti3dTisk

interface Props extends GetCourseListFilterOptions {
  reason: Reason | null
  openTraineeCourses: Entry<TypeProductEntitySkeleton, undefined, string>[]
  openNotTraineeCourses: Entry<TypeProductEntitySkeleton, undefined, string>[]
  productsColors: ProductsColorsItem[]
}

export const getStaticPaths: GetStaticPaths = async (): Promise<GetStaticPathsResult> => {
  const paths = reasons.map(({ slug }) => {
    return { params: { reason: slug } }
  })

  return {
    paths,
    fallback: false
  }
}

export const getStaticProps: GetStaticProps = async ({ params }): Promise<GetStaticPropsResult<Props>> => {
  const regionSlug = params?.reason as string
  const reason = (reasons || []).find((r) => r.slug === regionSlug)

  const contentfulProducts = await getAllProducts({ "fields.subType[in]": ["course"] })
  const openTraineeCourses = contentfulProducts.products.items.filter((p) => isProductAvailable(p))

  return {
    props: {
      openTraineeCourses,
      openNotTraineeCourses: [],
      productsColors: contentfulProducts.productsColors,
      ageGroup: CourseAgeGroup.children,
      type: CourseType.online,
      courseType: CourseVariant.course,
      reason
    },
    revalidate: process.env.NODE_ENV !== "production" ? 10 : 60 * 60
  }
}
